<template>
  <modal @close="$emit('close')">
    <div slot="header">
      <h4> {{ lead.ref_id }} - Send a follow up SMS</h4>
    </div>
    <div slot="body">
      <div class="container">
        <div class="row mb-4">
          <div class="col">
            <div class="select-wrap">
              <label>Send to</label>
              <p class="form-control">
                {{ customer_phone_selected ? phoneMask.maskedPhone(customer_phone_selected) : 'No phone added' }}
              </p>
            </div>
          </div>
          <div class="col pl-1">
            <div class="select-wrap">
              <label>Phone</label>
              <simple-select v-if="contacts.length > 0"
                             v-model="customer_phone_selected"
                             :options="contacts"
                             label="maskedPhone"
                             return-value="phone"
                             placeholder="Select Phone"
                             @input="getMessages"
              />
            </div>
          </div>
        </div>
        <div class="row mb-4 scrollable scrollableModal">
          <template v-if="thread.data">
            <div class="col-12" v-for="message in thread.data" :key="message.id">
              <template v-if="message.direction === 2">
                <div class="row">
                  <div class="col-9 bg-primary rounded">
                    <p class="m-1 text-white">{{ message.body }}</p>
                  </div>
                  <div class="col-3" />
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <small class="m-1">{{ message.date }}</small>
                  </div>
                </div>
              </template>
              <template v-else class="m-1">
                <div class="row">
                  <div class="col-3" />
                  <div class="col-9 bg-light rounded">
                    <p class="m-1">{{ message.body }}</p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col text-right">
                    <small class="m-1">{{ message.date }}</small>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
        <div class="row">
          <div class="col-10 pr-0">
            <div class="select-wrap h-auto">
              <label>
                {{ list ? lead.company : lead.company.name }}
                {{ phoneMask.maskedPhone(company_phone_selected) }}:
              </label>
              <div contenteditable="true">
                <textarea class="form-control"
                          v-model="newMessage"
                          @keypress.enter.prevent="sendFollowUpSMS"
                          :disabled="sending"
                />
              </div>
            </div>
          </div>
          <div class="col-2 pl-0">
            <button type="button"
                    class="pt-2 w-100 btn btn-primary ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    @click="sendFollowUpSMS"
                    :disabled="!newMessage || sending"
            >
              <span class="mod-icon-note" />
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-2">
            <error-field :errors="errors" field="message_limit" />
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" />
  </modal>
</template>

<script>
import axios from 'axios';
import moment from 'moment/moment';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';
import Modal from '../../Modal';
import PhoneMask from '../../../classes/PhoneMask';

export default {
  components: {
    ErrorField,
    Modal,
  },
  props: {
    lead: {
      type: Object,
      default: null,
    },
    list: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loadingButton: false,
    messages: {},
    contacts: [],
    customer_phone_selected: '',
    company_phone_selected: '',
    thread: {
      meta: null,
    },
    newMessage: '',
    sending: false,
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  created() {
    this.getPhoneNumbers();
  },
  methods: {
    getPhoneNumbers() {
      this.customer_phone_selected = this.lead.customer.phone;
      axios.get(`/phone-numbers/company/${this.lead.company_id}`).then(res => {
        this.company_phone_selected = res.data.data.filter(el => el.type.id === 1)[0].phone_number;
        this.getContacts();
        this.getMessages();
      });
    },
    getContacts() {
      axios.get(`/customers/${this.lead.customer.id}/contacts`).then(res => {
        this.contacts = res.data.data.map(elem => ({
          phone: elem.phone,
          maskedPhone: this.phoneMask.maskedPhone(elem.phone),
        }));
      });
    },
    getMessages() {
      axios
        .get(
          `leads/${this.lead.id}/text-messages?company_phone_number=${
            this.company_phone_selected
          }&customer_phone_number=${this.customer_phone_selected}`,
        )
        .then(res => {
          this.thread = res.data;
          this.$nextTick(() => {
            const el = document.querySelector('.scrollableModal');
            el.scrollTop = el.scrollHeight;
          });
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    sendFollowUpSMS() {
      if (!this.newMessage.trim()) {
        return;
      }
      this.sending = true;
      const sender = this.company_phone_selected;
      const newMessageObject = {
        from: sender,
        to: this.customer_phone_selected,
        type_id: 4,
        type: 4,
        notes: '',
        body: this.newMessage.trim(),
        date: moment().format('l LT'),
        direction: 2,
        sender: this.thread.meta.sender,
      };
      this.loadingButton = true;
      axios
        .post(`leads/${this.thread.meta.lead_id}/follow-ups`, { ...newMessageObject })
        .then(() => {
          this.thread.data.push(newMessageObject);
          this.newMessage = '';
          this.$nextTick(() => {
            const el = document.querySelector('.scrollableModal');
            el.scrollTop = el.scrollHeight;
          });
        })
        .catch(err => {
          if (
            err.response.data.error.exception &&
            err.response.data.error.exception[0] ===
              '[HTTP 400] Unable to create record: The concatenated message body exceeds the 1600 character limit.'
          ) {
            this.errors.record({
              message_limit: ['The message body exceeds the 1600 character limit.'],
            });
          } else {
            this.errors.record(err.response.data.error);
          }
        })
        .finally(() => {
          this.loadingButton = false;
          this.sending = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/leads/followUps/SMS.vue